<template>
  <div id="pageRomaneios">
    <v-container>
      <v-btn
        class="btn-add"
        color="white"
        small
        absolute
        fab
        :to="{ name: 'PropertyAdd' }"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-container>
    <v-container grid-list-xs fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <div v-if="!paginatationDisabled">
        <v-card>
          <v-card-text>
            <v-form @submit.prevent="searchProperty(1)">
              <v-layout row wrap>
                <v-flex md2 xs12>
                  <v-text-field
                    v-model="searchData.id"
                    label="Id"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 xs12>
                  <v-text-field
                    v-model="searchData.name"
                    label="Propriedade"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex md3 xs12>
                  <v-text-field v-model="searchData.document_number" label="Explorador (CPF/CNPJ)"></v-text-field>
                </v-flex>-->
                <v-flex md3 xs12>
                  <v-text-field
                    v-model="searchData.explorer"
                    label="Nome Produtor"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 xs12>
                  <v-text-field
                    v-model="searchData.user"
                    label="Usuário (Dono)"
                  ></v-text-field>
                </v-flex>

                <v-flex md3 xs12>
                  <v-select
                    v-model="searchData.state_id"
                    :items="states"
                    item-value="id"
                    item-text="state_initial"
                    v-on:change="getCities(searchData.state_id)"
                    label="Estado"
                  ></v-select>
                </v-flex>

                <v-flex md3 xs12>
                  <v-select
                    v-model="searchData.city_id"
                    :items="cities"
                    item-value="id"
                    item-text="name"
                    label="Cidade"
                  ></v-select>
                </v-flex>

                <v-flex md3 xs12>
                  <v-switch
                    v-model="searchData.isEmpty"
                    label="Dados incompletos"
                    :value="searchData.isEmpty"
                    hide-details
                  ></v-switch>
                </v-flex>

                <v-flex md3 xs12>
                  <br />
                  <v-btn
                    @click="searchProperty(1)"
                    small
                    class="ma-1"
                    color="primary"
                  >
                    <v-icon class="body-1">fa-search</v-icon>Buscar
                  </v-btn>
                  <v-btn
                    :to="{ name: 'PropertyIndex' }"
                    small
                    class="ma-1"
                    color="gray"
                    >Limpar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
        <br />
        <v-card>
          <v-card-text>
            <v-data-table
              v-if="properties.data"
              :headers="headers"
              :items="properties.data"
              :mobile-breakpoint="960"
              disable-pagination
              hide-default-footer
              disable-sort
              dense
            >
              <template v-slot:item.name="{ item }">
                <div class="py-2">
                  <span class="d-block">{{ item.name }}</span>
                  <span class="overline">{{ item.nr_car }}</span>
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">{{
                item.created_at | formatDate
              }}</template>

              <template v-slot:item.user.name="{ item }">
                <v-btn
                  class="indigo--text"
                  text
                  small
                  :to="{ name: 'User', params: { id: item.user.id } }"
                  >{{ item.user.name }}</v-btn
                >
              </template>

              <template v-slot:item.explorers="{ item }">
                <v-btn
                  text
                  :to="{
                    name: 'ExplorerIndex',
                    query: { property_id: item.id }
                  }"
                  small
                >
                  <span class="indigo--text">{{
                    item.explorers ? item.explorers.length : 0
                  }}</span>
                </v-btn>
              </template>

              <!-- <template v-slot:item.actions="{ item }">
                <v-btn
                  :to="{name : 'Property', params : {id : item.id}}"
                  small
                  icon
                  color="primary"
                >
                  <v-icon>fa-edit</v-icon>
                </v-btn>
              </template>-->
              <template v-slot:item.city="{ item }">
                <span v-if="item.city"
                  >{{ item.city.name }} /
                  {{ item.city.state.state_initial }}</span
                >
              </template>

              <template v-slot:item.actions="{ item }">
                <v-tooltip 
                  v-if="item.is_eco_active"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      color="success"
                      class="ma-1"
                      v-bind="attrs"
                      v-on="on"
                      @click="openPropertyDialog(item.id, item.name)"
                    >
                    <v-icon color="green" size="20">fas fa-unlock</v-icon>
                    </v-btn>
                  </template>

                  <span>Propriedade desbloqueada</span>
                </v-tooltip>

                <v-tooltip 
                  v-else
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      color="error"
                      class="ma-1"
                      v-bind="attrs"
                      v-on="on"
                      @click="openPropertyDialog(item.id, item.name)"
                    >
                      <v-icon color="red" size="20">fas fa-lock</v-icon>
                    </v-btn>
                  </template>

                  <span>Propriedade bloqueada</span>
                </v-tooltip>

                <v-btn
                  small
                  icon
                  class="ma-1 mt-2"
                  @click="redirectProperty(item.id)"
                >
                  <v-icon size="20">fa-edit</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <app-pagination
          v-if="properties && properties.pagination"
          :pagination="properties.pagination"
          :disabled="paginatationDisabled"
          v-on:change-page="searchProperty"
        ></app-pagination>
      </div>

      <app-confirm-modal
        :message="deleteMessage"
        :dialog="dialog"
        :modalType="modalType"
        v-on:choose="disableProperty"
      ></app-confirm-modal>

      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>

      <v-dialog v-model="propertyStateDialog.show" persistent max-width="410">
        <v-card>
          <v-card-title class="headline red white--text">Alterar status da propriedade</v-card-title>
          <v-card-text class="pt-4">Tem certeza que deseja alterar o status da propriedade <b>{{ propertyStateDialog.propertyName }}</b> ?</v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="red" dark @click="propertyStateDialog.show = false">Não</v-btn>
            <v-btn color="success" dark :loading="loadingProperty" @click="changePropertyActive(propertyStateDialog.propertyId)">Sim</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import appApi from "../../plugins/api";
import AppPagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";
import moment from "moment";

export default {
  components: {
    "app-pagination": AppPagination,
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      headers: [
        { text: "Id", value: "id", sortable: false },
        { text: "Propriedade / CAR", value: "name", sortable: false },
        { text: "Usuário (Dono)", value: "user.name", sortable: false },
        { text: "E-mail (Dono)", value: "user.email", sortable: false },
        { text: "Produtores", value: "explorers", sortable: false },
        { text: "Cidade / Estado", value: "city", sortable: false },
        { text: "Data cadastro", value: "created_at", sortable: false },
        { text: "Ações", value: "actions", sortable: false }
        // { text: 'Ações', value: 'actions', sortable: false }
      ],
      propertyStateDialog:{
        show: false,
        propertyName: null,
        propertyId: null,
      },
      properties: {},
      currentPage: 1,
      paginatationDisabled: false,
      dialog: false,
      snackbarCsv: false,
      updateIdx: null,
      deleteMessage: "",
      modalType: null,
      snackbar: {},
      searchData: {},
      formatDates: {
        intlDate: "YYYY-MM-DD",
        ini: {
          date: "",
          modalDateInit: false
        },
        end: {
          date: "",
          modalDateInit: false
        }
      },
      states: [],
      cities: [],
      loadingProperty: false
    };
  },

  computed: {},

  mounted: function() {
    window.scrollTo(0, 0);

    if (this.$route.query.page) {
      this.searchData["page"] = this.$route.query.page;
    } else {
      this.searchData["page"] = 1;
    }

    if (this.$route.query.id) {
      this.searchData["id"] = this.$route.query.id;
    }
    if (this.$route.query.name) {
      this.searchData["name"] = this.$route.query.name;
    }
    if (this.$route.query.document_number) {
      this.searchData["document_number"] = this.$route.query.document_number;
    }
    if (this.$route.query.user) {
      this.searchData["user"] = this.$route.query.user;
    }
    if (this.$route.query.state_id) {
      this.searchData["state_id"] = this.$route.query.state_id;
    }
    if (this.$route.query.city_id) {
      this.searchData["city_id"] = this.$route.query.city_id;
      this.getCities(this.searchData.state_id);
    }

    if (this.$route.query.explorer) {
      this.searchData["explorer"] = this.$route.query.explorer;
    }
    if (this.$route.query.isEmpty) {
      this.searchData["isEmpty"] = this.$route.query.isEmpty;
    }

    this.getProperties(this.searchData);

    appApi.getAddressStates().then(result => {
      this.states = result.data;
    });
  },

  methods: {
    redirectProperty(value) {
      this.$router.push({
        name: "Property",
        params: {
          id: value
        }
      });
    },
    searchProperty: function(page) {
      let data = { page: page ? page : 1 };

      if (this.searchData.id) {
        data["id"] = this.searchData.id;
      }
      if (this.searchData.document_number) {
        data["document_number"] = this.searchData.document_number.replace(
          /\D/g,
          ""
        );
      }
      if (this.searchData.name) {
        data["name"] = this.searchData.name;
      }
      if (this.searchData.user) {
        data["user"] = this.searchData.user;
      }

      if (this.searchData.state_id) {
        data["state_id"] = this.searchData.state_id;
      }
      if (this.searchData.city_id) {
        data["city_id"] = this.searchData.city_id;
      }
      if (this.searchData.explorer) {
        data["explorer"] = this.searchData.explorer;
      }
      if (this.searchData.isEmpty) {
        data["isEmpty"] = this.searchData.isEmpty;
      }
      this.$router.push({ name: "PropertyIndex", query: data });
    },

    getProperties: function(data) {
      this.paginatationDisabled = true;
      this.properties.data = [];
      appApi
        .getProperties(data)
        .then(result => {
          this.properties = result.data;
          this.paginatationDisabled = false;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    getCities(state_id) {
      appApi.getAddressCities({ state_id }).then(result => {
        this.cities = result.data;
      });
    },

    openPropertyDialog(id, property) {
      this.propertyStateDialog.propertyId = id
      this.propertyStateDialog.propertyName = property
      this.propertyStateDialog.show = true
    },

    changePropertyActive(id) {
      this.loadingProperty = true
      appApi.putPropertyActive( id ).then(result => {
        this.loadingProperty = false
        this.propertyStateDialog.show = false
        this.getProperties();
        this.snackbar = {
          text: 'Propriedade alterada com sucesso',
          color: 'success',
          show: true
        }
      });
    },

    disableProperty() {}
  }
};
</script>
<style scoped lang="css">
>>> .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

#pageRomaneios .btn-add {
  position: fixed;
  top: 90px;
  left: calc(100% - 60px);
}
</style>
